export default __webpack_public_path__ + "static/media/EcImage.340d3f2a.png";